import React from 'react';
import styled from 'styled-components';
import { images } from '../../../assets/images';
import { AuthCard, AuthInner, AuthLogo, AuthLink } from './AuthUi';

export interface VerifyEmailScreenProps {
  email?: string;
  onBackToLogin: () => void;
}

export const VerifyEmailScreen = (props: VerifyEmailScreenProps) => (
  <AuthCard>
    <AuthInner>
      <AuthLogo src={images.risenHopeLogo} alt="Risen Hope" />
      <CenteredContent>
        <Title>Verify your email</Title>
        <SubText>Your email is not verified. Please verify it before logging in.</SubText>
        <SubText>You must have received an email with a verification link.</SubText>
        {!!props.email && <EmailText>{props.email}</EmailText>}
        <Spacer $size={28} />
        <AuthLink onClick={props.onBackToLogin}>Back to Login</AuthLink>
      </CenteredContent>
    </AuthInner>
  </AuthCard>
);

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Title = styled.h2`
  font-family: Nunito, sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px;
`;

const SubText = styled.p`
  font-family: Nunito, sans-serif;
  font-size: 15px;
  color: #666;
  line-height: 24px;
  margin: 0 0 8px;
`;

const EmailText = styled.p`
  font-family: Nunito, sans-serif;
  font-size: 14px;
  color: #999;
  margin: 8px 0 0;
`;

const Spacer = styled.div<{ $size?: number }>`
  height: ${p => p.$size ?? 16}px;
`;
